import React, { useEffect, useState } from "react";
import Text from "theme/Text";
import { useNavigation, useRoute } from "@react-navigation/native";
import { useDispatch, useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import _ from 'lodash';
import { StyleSheet, View } from "react-native";
import { AppRoutes } from "navigations/app-routes";
import ObjectBooking from "utils/objects/booking";
import ObjectLunchOption from "utils/objects/lunch-option";
import i18n from "utils/i18n";
import Translate from "utils/translate";
import { cartConstants } from "services/redux/cart/constants";
import { addCartTimeslotLunchOptions } from "services/redux/cart/actions";
import { textStyles } from "styles/text";
import FetchTimeslotCapacity from "utils/fetch/FetchTimeslotCapacity";
import { colorList } from "utils/colors";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedBlock from "components/atoms/ThemedBlock";
import SelectLunch from "components/molecules/SelectLunch";
import { bookingOptions, isBookForMyself } from "utils/constants/booking-constants";
import { ThemedValues } from 'styles/themed'
import HelperString from 'utils/helper-string'
import BookingFooter from 'scenes/home/book/_components/BookingFooter'
import { getNavigateToFromSelect } from "components/atoms/BookingCreate";
import LunchBookings from 'scenes/home/book/lunch/_components/LunchBookings'
import LoadingComponent from 'components/atoms/Loading'
import { timeslotKindConstants } from 'utils/constants/timeslot-kind-constants'
import { routeBookingConstants } from 'utils/constants/route/RouteBookingConstants'
import { selectCartEmployees, selectCartTimeslotsByKind } from 'services/redux/cart/reducers'
import useRouteParameters from 'utils/hooks/use-route-parameters'
import VStack from 'components/atoms/stack/VStack'

const HomeBookLunchScene = () => {
	const route = useRoute();
	const dispatch = useDispatch()
	const navigation = useNavigation();
	const _routeParameters = useRouteParameters( route );
	
	const [ loading, setLoading ] = useState( true )
	const [ footerHeight, setFooterHeight ] = useState( 0 )
	
	const _employee  = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} );
	const _buildings = useSelector( state => {
		return state.data[dataConstants.BUILDINGS];
	} );
	const _floors    = useSelector( state => {
		return state.data[dataConstants.FLOORS];
	} );
	const _rooms     = useSelector( state => {
		return state.data[dataConstants.ROOMS];
	} );
	const _lunchOptions = useSelector( state => {
		return state.data[dataConstants.LUNCH_OPTIONS];
	} );
	
	const _cartEmployees = useSelector( selectCartEmployees );
	const _cartTimeslotsLunchOptions = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS_LUNCH_OPTIONS];
	} );
	const _cartTimeslotsLunch = useSelector( state => {
		return selectCartTimeslotsByKind(state, timeslotKindConstants.LUNCH);
	} );
	
	const _bookForOption = _.get( _routeParameters, routeBookingConstants.FOR_OPTION );
	const building = _.find( _buildings, { guid: _.get( _routeParameters, routeBookingConstants.BUILDING, null ) } );
	const floor = _.find( _floors, { guid: _.get( _routeParameters, routeBookingConstants.FLOOR, null ) } );
	const room = _.find( _rooms, { guid: _.get( _routeParameters, routeBookingConstants.ROOM, null ) } );
	
	const employeeDefaultLunchOption = _.get( _employee, ['lunch_option', 'guid'], null );
	const [ employeeLunchOptionGuid, setEmployeeLunchOptionGuid ] = useState( employeeDefaultLunchOption );
	const [ selectedLunchOption, setSelectedLunchOption ] = useState( null );
	
	const { navigateTo, label } = getNavigateToFromSelect( AppRoutes.ADD_BOOKING_LUNCH, isBookForMyself( _bookForOption ) );
	
	const onSelectAllLunchOptions = ( { selected, force = false } = {} ) => {
		setSelectedLunchOption( selected );
		
		// Get the available lunches
		const lunches = _.filter( getLunches(), o => {
			const availableLunchOptions = ObjectLunchOption.getOptions( {
				building: o.building,
				floor: o.floor,
				room: o.room,
			} );
			
			return !_.isEmpty( _.find( availableLunchOptions, {
				guid: selected
			}));
		})
		
		// Create the store data
		const payload = {};
		_.forEach( lunches, lunch => {
			const key = FetchTimeslotCapacity.keyByBooking( lunch );
			
			// Check if we must set
			if( force || getSelectedLunchOption( _employee, lunch ) === null ) {
				payload[ key ] = {
					[ _employee.guid ]: selected
				};
			}
		});
		
		if( !_.isEmpty( payload ) ) {
			dispatch( addCartTimeslotLunchOptions( payload ) );
		}
	}
	
	const getSelectedLunchOption = ( employee, item ) => {
		const itemKey = FetchTimeslotCapacity.keyByBooking( item );
		
		return _.get( _cartTimeslotsLunchOptions, [ itemKey, employee.guid ], null );
	}
	
	const getLunches = () => {
		// Get all the lunches sorted by date
		const lunches = _.filter( _.sortBy( _cartTimeslotsLunch, 'booking_date' ), o => {
			return !ObjectBooking.didAlreadyBook( [ o ] );
		});
		
		// Create the records with selects
		return _.map( lunches, lunch => {
			
			//
			let selectedLunchOptions = {};
			_.forEach( _cartEmployees, employee => {
				selectedLunchOptions[ employee.guid ] = getSelectedLunchOption( employee, lunch );
			})
			
			return {
				...lunch,
				selectedLunchOption: selectedLunchOptions
			}
		});
	}
	
	const selectLunchOption = ( employee, { selected, item = null } = {} ) => {
		if( item !== null ) {
			const itemKey = FetchTimeslotCapacity.keyByBooking( item );
			
			// Only trigger when different
			if( _.get( _cartTimeslotsLunchOptions, [ itemKey, employee.guid ], null ) !== selected ) {
				dispatch( addCartTimeslotLunchOptions( {
                    [ itemKey ]: {
						..._cartTimeslotsLunchOptions[ itemKey ],
						[ employee.guid ]: selected
                    }
                }));
			}
		}
	}
	
	const onNextPagePress = () => {
		navigation.navigate( navigateTo, _routeParameters );
	}
	
	useEffect( () => {
		if( employeeLunchOptionGuid !== null ) {
			onSelectAllLunchOptions( {
				selected: employeeLunchOptionGuid
			});
		}
		
		setLoading( false )
	}, [] );
	
	const title = [
		i18n.t('page.create.lunch.title' )
	];
	const subtitle = _.filter( [] );
	
	const days = {};
	_.forEach( getLunches(), booking => {
		const date = booking.booking_date;
		if( !_.has( days, date ) ) {
			days[ date ] = {};
		}
		
		const { key, title } = ObjectBooking.extractKeyTitle( booking, {
			_buildings,
			_floors,
			_rooms
		})
		
		if( !_.has( days[ date ], key ) ) {
			days[ date ][ key ] = {
				title: title,
				data: []
			};
		}
		
		days[ date ][ key ].data.push( booking );
	});
	
	const employeeDefaultLunchOptionObject = _.get( _lunchOptions, employeeDefaultLunchOption, {} );
	
	let content = <LoadingComponent />
	if( !loading ) {
		content = [];
		
		if( !_.isEmpty( employeeDefaultLunchOptionObject ) ) {
			content.push(
				<ThemedBlock
					key={ HelperString.hash( "book-lunch-default-lunch" ) }
					mediumPadding
					shadow>
					
					<Text
						style={ [
							textStyles.textCenter,
							styles.textPaddingBottom0
						] }>
						
						{ i18n.t('page.create.lunch.profile_default') }
					</Text>
					
					<Text
						category={ "s1" }
						style={ [
							textStyles.textCenter,
							styles.textColorPrimary
						] }>
						
						{ Translate.field( employeeDefaultLunchOptionObject, 'title' ) }
					</Text>
					
					{ !isBookForMyself( _bookForOption ) && (
						<Text
							style={ [
								textStyles.textCenter,
								styles.textColorPrimary2
							] }>
							
							{ i18n.t('page.create.lunch.option_only_myself') }
						</Text>
					)}
				</ThemedBlock>
			)
		}
		
		// Select all field
		if( _.size( days ) > 1 && _bookForOption === bookingOptions.MYSELF ) {
			content.push(
				<ThemedBlock
					key={ HelperString.hash( "book-lunch-days" ) }
					mediumPadding
					shadow
					style={ styles.selectAllContainer }>
					
					{/* Intro text */}
					<View style={ styles.viewMarginBottomMarginHorizontal }>
						<Text>{ i18n.t('page.create.lunch.intro') }</Text>
					</View>
					
					{/* Select all */}
					<View>
						<SelectLunch
							building={ building }
							floor={ floor }
							room={ room }
							select={ ( { selected } ) => {
								return onSelectAllLunchOptions({
									selected,
									force: true
								});
							} }
							selected={ _.get( selectedLunchOption, _employee.guid, null ) }
						/>
					</View>
				</ThemedBlock>
			)
		}
		
		// The timeslot icons
		content.push(
			<LunchBookings
				key={ HelperString.hash( "book-lunch-default-lunch-bookings" ) }
				days={ days }
				onSelect={ selectLunchOption }
			/>
		)
		
		if( _.isEmpty( employeeDefaultLunchOptionObject ) ) {
			content.push(
				<ThemedBlock
					key={ HelperString.hash( "book-lunch-default-lunch-text" ) }
					mediumPadding
					shadow>
					
					<Text style={ styles.hint }>{ i18n.t('page.create.lunch.profile_default_not_set') }</Text>
				</ThemedBlock>
			)
		}
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				contentWidth="narrow"
				topNavigation={ true }
				showBackButton={ true }
				title={ title.join(' - ') }
				subtitle={ subtitle.join(' - ') }
				style={ {
					paddingBottom: footerHeight + 10
				} }>
				
				<VStack space={ ThemedValues.stackSpace }>
					{ content }
				</VStack>
			</ThemedLayout>
			
			<BookingFooter
				onHeight={ setFooterHeight }
				onPressSubmit={ onNextPagePress }
				submitLabel={ label }
			/>
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeBookLunchScene

const styles = StyleSheet.create({
	textPaddingBottom0: {
		paddingBottom: 0,
	},
	textColorPrimary: {
		color: colorList.PRIMARY.primary,
	},
	textColorPrimary2: {
		color: colorList.RED.primary,
	},
	viewMarginBottomMarginHorizontal: {
		marginBottom: ThemedValues.marginHorizontal,
	},
	selectAllContainer: {
		backgroundColor: '#fff',
		marginBottom: ThemedValues.marginHorizontal,
		borderRadius: 4,
	},
	hint: {
		fontSize: 14,
		fontStyle: 'italic'
	}
});
